import { NotEmptyName } from '@/Domain/Name'

export class BatchMount extends NotEmptyName {}
